import React, { useState, useEffect } from 'react';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { axios } from '../../services/axios';
import swal from 'sweetalert2';

const EditMenuTypeModal = ({ isOpen, toggle, menuType, onSuccess }) => {
  const [formData, setFormData] = useState({
    translations: {
      en: { name: '' },
      ar: { name: '' }
    }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (menuType) {
      setFormData({
        translations: {
          en: { name: menuType.translations.find(t => t.locale === 'en')?.name || '' },
          ar: { name: menuType.translations.find(t => t.locale === 'ar')?.name || '' }
        }
      });
    }
  }, [menuType]);

  const handleChange = (e, locale) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      translations: {
        ...prev.translations,
        [locale]: {
          ...prev.translations[locale],
          [name]: value
        }
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await axios.put(`/menu-types/${menuType.id}`, formData);
      swal.fire({
        title: 'Success',
        type: 'success',
        text: 'Menu type updated successfully!',
        timer: 3000,
      });
      onSuccess();
    } catch (error) {
      console.error('Error updating menu type:', error);
      swal.fire({
        title: 'Error',
        type: 'error',
        text: error.response?.data?.message || 'Failed to update menu type',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Menu Type</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label>Name (English)</Label>
            <Input
              type="text"
              name="name"
              value={formData.translations.en.name}
              onChange={(e) => handleChange(e, 'en')}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label>Name (Arabic)</Label>
            <Input
              type="text"
              name="name"
              value={formData.translations.ar.name}
              onChange={(e) => handleChange(e, 'ar')}
              required
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={loading}>
            {loading ? 'Updating...' : 'Update'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default EditMenuTypeModal;
